import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#b59a70" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/pages/Mr.%20Bro%20Korean%20Bistro%20&%20Izakaya/545505405854190/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Mr Bro Facebook"
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/mr-bro-korean-bistro-and-izakaya-richmond-6">
              <CFImage w="45px" pr="10px" src={yelp} alt="Mr Bro Yelp" />
            </CFLink>
            {/* <CFLink href="https://www.zomato.com/vancouver/88-palpal-noodle-house-central-burnaby-burnaby">
              <CFImage w="45px" pr="10px" src={zomato} alt="Mr Bro Zomato" />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/mr_bro_izakaya/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Mr Bro Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#b59a70" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/pages/Mr.%20Bro%20Korean%20Bistro%20&%20Izakaya/545505405854190/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Mr Bro Facebook"
                hover
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/mr-bro-korean-bistro-and-izakaya-richmond-6">
              <CFImage w="45px" pr="10px" src={yelp} alt="Mr Bro Yelp" hover />
            </CFLink>
            {/* <CFLink href="https://www.zomato.com/vancouver/88-palpal-noodle-house-central-burnaby-burnaby">
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Mr Bro Zomato"
                hover
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/mr_bro_izakaya/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Mr Bro Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
